module.exports = __webpack_public_path__ + "static/media/shelcia_resume.f9661884.pdf";